/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_bZ_98_90 as Componente_bZ_98_90,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
} from "../../runtime/index.jsx";
export function HorarioMovilidad() {
  let e = Go(),
    [t, n] = (0, React.useState)(``),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(`60`),
    [s, c] = (0, React.useState)(!0),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(!1),
    m = (0, React.useCallback)(async () => {
      c(!0);
      try {
        let e = await api(`/transporte/horario-atencion`);
        (n(e.desde), i(e.hasta), o(e.anticipacionMinutos ?? `60`), u(``));
      } catch (e) {
        u(e.message);
      } finally {
        c(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    m();
  }, [m]);
  async function h(n) {
    if ((n.preventDefault(), !f)) {
      p(!0);
      try {
        (await api(`/transporte/horario-atencion`, {
          method: `POST`,
          body: JSON.stringify({
            desde: t,
            hasta: r,
            anticipacionMinutos: a,
          }),
        }),
          e.ok(`Horario guardado`));
      } catch (t) {
        e.error(t.message);
      } finally {
        p(!1);
      }
    }
  }
  return (
    <section
      className={`${Bo} flex flex-col gap-3`}
      children={[
        <div
          children={[
            <p
              className={`font-medium text-(--text-h)`}
              children={`Horario de atención`}
            />,
            <p
              className={`text-sm text-(--text)`}
              children={`Fuera de estas horas se avisa el horario y no se toma el pedido. Una salida deja de ofrecerse cuando falta menos de la anticipación que pongas.`}
            />,
          ]}
        />,
        <EstadoError mensaje={l} onReintentar={m} />,
        s ? (
          <Componente_bZ_98_90 />
        ) : (
          <form
            onSubmit={h}
            className={`flex flex-wrap items-end gap-3`}
            children={[
              <label
                className={`flex flex-col gap-1 text-sm text-(--text)`}
                children={[
                  `Desde`,
                  <input
                    type={`time`}
                    value={t}
                    onChange={(e) => n(e.target.value)}
                    className={`${Lo} w-32`}
                  />,
                ]}
              />,
              <label
                className={`flex flex-col gap-1 text-sm text-(--text)`}
                children={[
                  `Hasta`,
                  <input
                    type={`time`}
                    value={r}
                    onChange={(e) => i(e.target.value)}
                    className={`${Lo} w-32`}
                  />,
                ]}
              />,
              <label
                className={`flex flex-col gap-1 text-sm text-(--text)`}
                children={[
                  `Pedir con`,
                  <div
                    className={`flex items-center gap-2`}
                    children={[
                      <input
                        type={`number`}
                        min={`0`}
                        max={`720`}
                        step={`15`}
                        value={a}
                        onChange={(e) => o(e.target.value)}
                        className={`${Lo} w-24`}
                      />,
                      <span
                        className={`text-sm text-(--text)`}
                        children={`minutos de anticipación`}
                      />,
                    ]}
                  />,
                ]}
              />,
              <button
                type={`submit`}
                disabled={f}
                className={Ro}
                children={f ? `Guardando…` : `Guardar`}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
